module.exports = __webpack_public_path__ + "static/img/scene_5.9cdae25b.png";